import { ServiceCodeBySystem, IntegrationSystem } from '@/shared/types';

import { config } from '@/config/index';

import { RouteConfig } from '@/router/types';

export const PAY_ROUTES: Record<keyof ServiceCodeBySystem<IntegrationSystem.PAY> | 'PAYMENT_RECEIPTS', RouteConfig> = {
  PAYMENT_RECEIPTS: { basePath: config.router.userPath, path: 'payment-receipts', isPrivate: true },
  PAYMENT_WITHOUT_APPLICATION: {
    basePath: config.router.servicePath,
    path: 'payment-without-application',
    isPrivate: false,
  },
};
